<template>
  <!-- D: 컨텐츠 탭 : 주문내역 -->
  <div class="c-inline-tabs">
    <ul>
      <!-- D: 활성화시 is-active 및 aria-selected 추가 -->
      <li class="tab-item">
        <a
          href="javascript:void(0);"
          class="tab-anchor"
          :class="{ 'is-active': tabIndex == 0 }"
          role="tab"
          v-bind="tabIndex == 0 ? { 'aria-selected': '' } : {}"
          @click="selectTab(0)"
        >
          주문서
        </a>
      </li>
      <li class="tab-item">
        <a
          href="javascript:void(0);"
          class="tab-anchor"
          :class="{ 'is-active': tabIndex == 1 }"
          role="tab"
          v-bind="tabIndex == 1 ? { 'aria-selected': '' } : {}"
          @click="selectTab(1)"
        >
          제품별
        </a>
      </li>
    </ul>
  </div>
  <!-- D: c-inline-tab-panel과 c-inline-tab-panel-wrap은 세트임 -->
  <div class="c-inline-tab-panel-wrap">
    <!-- tab content: tab1(주문서) -->
    <div class="tab-panel" role="tabpanel" aria-labelledby="tab5-1">
      <OrderDetailTab v-if="tabIndex == 0" />
    </div>
    <!-- tab content: tab2(제품별) -->
    <div class="tab-panel" role="tabpanel" aria-labelledby="tab5-2">
      <ProdListTab v-if="tabIndex == 1" />
    </div>
  </div>
  <!-- // D: 컨텐츠 탭 : 주문내역 -->
</template>
<script setup name="orderHistoryCont">
import OrderDetailTab from "@/components/paintpro/order/orderDetailTab.vue";
import ProdListTab from "@/components/paintpro/order/prodListTab.vue";
import { computed } from "vue";
import * as store from "@/store";

function selectTab(idx) {
  store.useOrderListStatusStore().setOrderListTabIdx(idx);
}

const tabIndex = computed(
  () => store.useOrderListStatusStore()?.orderListTabIdx
);
</script>
